import API from ".";

export default class User {
  /**
   * @param {boolean} isAdmin
   * @param {boolean} isPhoenix
   * @param {boolean} isCxUser
   */
  constructor({ isAdmin, isPhoenix, isCxUser }) {
    this.isAdmin = isAdmin;
    this.isPhoenix = isPhoenix;
    this.isCxUser = isCxUser;
  }

  static async getUserGroups() {
    const api = await API();
    const { data } = await api.get("/users");
    return data;
  }
}
